// @ts-nocheck

/* eslint-disable @typescript-eslint/consistent-type-imports */
import * as React from 'react'
import { SVGProps, memo } from 'react'

const CheckboxMinus = (props: SVGProps<SVGSVGElement> & { slot?: string }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={20} height={20} rx={5} fill="#FFFFFC" />
    <rect x={7} y={9} width={6} height={2} rx={1} fill="currentColor" />
  </svg>
)

const Memo = memo(CheckboxMinus)
export default Memo
